module.exports = __webpack_public_path__ + "static/italy-017304402c5304270a3fbbfc78f2fbdf.jpeg";